import { stockService } from "@/_services";
export const stock = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    excel: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getStockRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getStockSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getStockError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    getExcelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    getExcelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
    getExcelSuccess(state, response) {
      state.excel.data = response;
      state.excel.status = {
        downloaded: true,
      };
    },
  },
  actions: {
    getStock({ commit }, request) {
      commit("getStockRequest");
      stockService
        .getStock(request.pagination, request.query)
        .then((response) => {
          commit("getStockSuccess", response);
        })
        .catch((error) => {
          commit("getStockError", error);
        });
    },
    getExcel({ commit }, filters) {
      commit("getExcelRequest");
      stockService
        .getExcel(filters)
        .then((res) => {
          commit("getExcelSuccess", res);
        })
        .catch((error) => {
          commit("getExcelError", error);
        });
    },
  },
};
